import React from 'react';
import { Clock, Flame } from 'lucide-react';
import { useCountdown } from './ui';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(4);
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-brand-red via-brand-orange to-brand-red text-white py-3 px-4 shadow-lg shadow-brand-orange/20 border-b border-white/10" data-id="element-178">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-center" data-id="element-179">
        <div className="flex items-center gap-2 font-bold text-sm md:text-base tracking-wide" data-id="element-180">
          <Flame className="w-4 h-4 md:w-5 md:h-5 animate-pulse text-brand-gold" data-id="element-181" />
          <span data-id="element-182">
            ¡OFERTA DE LANZAMIENTO! 75% DE DESCUENTO PARA NUESTRA COMUNIDAD
            HISPANA
          </span>
        </div>
        <div className="flex items-center gap-2 bg-black/30 px-3 py-1 rounded-md font-mono text-lg md:text-xl font-bold" data-id="element-183">
          <Clock className="w-4 h-4 md:w-5 md:h-5 text-brand-gold" data-id="element-184" />
          <span data-id="element-185">
            {hours}:{minutes}:{seconds}
          </span>
        </div>
      </div>
    </div>;
}